var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocialFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0V40H40V0H0ZM28.7744 5.21973C29.0649 5.21357 29.3674 5.223 29.6802 5.24413C30.8294 5.2457 32.0296 5.3493 33.2202 5.4541L33.0908 10.1904H29.8926C28.393 10.1572 27.8514 10.7395 27.8027 12.4316V16.1523H33.2202L33.0054 21.2256H27.8027V35.3491H22.5171V21.2256H18.8477V16.1523H22.5171V11.7969C22.5171 8.65657 23.8447 6.65773 26.46 5.64453C27.1316 5.38027 27.9029 5.23823 28.7744 5.21973Z",
    fill: "#CCFBF1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialFacebook);
export default __webpack_public_path__ + "static/media/social Facebook.1f757424736c72450992e08fa9d83694.svg";
export { ForwardRef as ReactComponent };